const colorCodes = {
    0: "#22ABBD", 
    3: "#F28903", 
    65535: "reset"
  };
const emotes = {
  0: "neutral",
  2: "happiness",
  3: "joy",
  4: "love",
  5: "sheepishness",
  6: "happiness-like",
  7: "shine with happy",
  9: "aggrivation",
  11: "worry",
  12: "sighing",
  13: "thought",
  14: "sadness",
  15: "distress",
  16: "sorrow",
  17: "heartbreak",
  18: "resignation",
  20: "laughter",
  21: "glee",
  23: "flourish",
  24: "showmanship",
  26: "amazed",
  27: "surprise",
  28: "shocked-like",
  29: "shocked",
  30: "inspiration",
  31: "mistaken",
  32: "lightly amazed",
  33: "encouraging",
  34: "greetings",
  35: "apologetic",
  36: "pleased",
  37: "agreement",
  38: "curiosity",
  39: "disagreement",
  40: "confident",
  41: "explaining",
  42: "cold chill",
  43: "fearful",
  44: "sneezing",
  46: "sleepy",
  47: "dozing",
  49: "daydreaming",
  50: "bashfulness",
  51: "mischief",
  52: "shyness",
  53: "pride",
  54: "smirking",
  55: "eyes to the side",
  56: "arms close, eyes up, frown",
  57: "intense-like",
  58: "intense",
  59: "bewilderment"
};

interface FunctionArgMap {
  [id: number]: any
}

function getArgName(map: FunctionArgMap, id: number, default_?: any) {
  if (id in map) return map[id];
  return default_ === undefined ? id : default_;
}

export const knownFuncs = {
  0: function(args: number[]) {
    if (args[0] === 0) {
      let hint = "";
      for (let i = 0;  i < args[2] / 2; i++) hint += String.fromCodePoint(args[3+i]);
      return "displayHint("+args[1]+" chars, \""+hint+"\")";
    }
    if (args[0] === 2) return "setTextSize("+args[1]+")";
    if (args[0] === 3) {
      const colorNum = args[1];
      let colorCode = getArgName(colorCodes, args[1]);
      return "setTextColor("+colorCode+")";
    }
    if (args[0] === 4) return "nextPage()";
    return null;
  },
  10: function(args: number[]) {
    if (args[0] === 2) return "shortPause()";
    return null;
  },
  40: function(args: number[]) {
    if (args[1] === 52480 && args[2] == 0) return "emote("+getArgName(emotes, args[0])+")";
    return null;
  },
  50: function(args: number[]) {
    if (args[0] === 0 && args.length === 3 && args[2] === 52483) {
      const known = {256: "singular indefinite consonant", 512: "singular indefinite vowel", 1024: "plural"}
      let str = getArgName(known, args[1], null);
      if (str === null) return null;
      return "wordInfo("+(known as any)[args[1]]+")";
    }
    if (args.length === 1 && args[0] === 2) return "getWordArticle()";
    return null;
  },
  90: function(args: number[]) {
    if (args[1] === 0 && args.length === 2) {
      const known = {
        2: "item present in storage/pockets",
        17: "bells",
        20: "Daisy turnip price",
        21: "price offered to buy item",
        26: "Daisy turnip price"
      };
      let name = getArgName(known, args[0]);
      return "getNum("+name+")";
    }
    if (args[1] === 52480) {
      const known = {
        35: "month",
        36: "day",
        37: "hour",
        38: "minute"
      };
      let name = getArgName(known, args[0]);
      return "getVal("+name+")";
    }
    return null;
  },
  110: function(args: number[]) {
    if (args.length === 1) {
      const known = {
        0: "\"...\"",
        1: "player name",
        3: "nickname",
        5: "catchphrase",
        9: "player's island"
      };
      let name = getArgName(known, args[0]);
      return "getStr("+name+")";
    }
    return null;
  },
  115: function(args: number[]) {
    if (args.length === 1) {
      const known = {
        0: "some player name",
        1: "some player name",
        2: "some island name"
      }
      let name = getArgName(known, args[0]);
      return "getStr("+name+")";
    }
    return null;
  }
}

export function getFuncStr(func: any[]) {
  if (func[0] in knownFuncs) {
    let ans = (knownFuncs as any)[func[0]](func[1]);
    if (ans !== null) return ans;
  }
  return "F"+func[0]+"("+func[1].join(", ")+")";
}